export default __webpack_public_path__ + "static/media/truck-sign-in@3x.6d681cbf.png";